import { render, staticRenderFns } from "./CreateEditClient.vue?vue&type=template&id=b04b5530&scoped=true"
import script from "./CreateEditClient.vue?vue&type=script&lang=js"
export * from "./CreateEditClient.vue?vue&type=script&lang=js"
import style0 from "./CreateEditClient.vue?vue&type=style&index=0&id=b04b5530&prod&scoped=true&lang=css"
import style1 from "./CreateEditClient.vue?vue&type=style&index=1&id=b04b5530&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04b5530",
  null
  
)

export default component.exports